export default __webpack_public_path__ + "d2f1a9474d2364b51df8e6493ce3d11e.svg";